import { createSlice } from "@reduxjs/toolkit";

export const createMenuSlice = () => {
  return createSlice({
    name: "menu",
    initialState: {
      menuToggleFlag: false,
      menuGalleryToggleFlag: false,
      menuChatToggleFlag: false,
      disableResizeFunctions: false,
    },
    reducers: {
      toggleMenu(state) {
        state.menuToggleFlag = !state.menuToggleFlag;
      },
      goToGallery(state) {
        state.menuGalleryToggleFlag = !state.menuGalleryToggleFlag;
      },
      goToChat(state) {
        state.menuChatToggleFlag = !state.menuChatToggleFlag;
      },
      disableResizeFunctions(state, action) {
        state.disableResizeFunctions = action.payload;
      },
    },
  });
};
